import { openExternalUrl } from './openExternalUrl';

export type BillingBrowserResult = 'success' | 'cancel' | 'dismiss';

export function billingDeepLinkPrefix(): string {
  return '';
}

/**
 * Web: navigates away to Stripe. Caller should not treat this as Checkout done —
 * Return lands on `/thanks`. “Open dashboard” uses `?billing=success`.
 */
export async function openBillingBrowser(url: string): Promise<BillingBrowserResult> {
  await openExternalUrl(url);
  // Page unloads; if somehow still running, don't open Pro welcome here.
  return 'dismiss';
}
